import qs from 'qs';

import LogUtils from "../utils/LogUtils";

class BaseService {

  constructor() {
    this.TAG = "BaseService";
    this.HTTP_METHODS = {
      GET: 'get',
      POST: 'post',
      PUT: 'put',
      DELETE: 'delete'
    }
    this.VC_AG_TKN = "vc_ag_ag_tkn";
    this.FAILED_TO_PERFORM_OPERATION = "Não foi possível executar esta operação";

    this.logUtils = new LogUtils();
  }

  getBasicHttpRequest(method, url, headers, data, dontStringify) {
    const request = {
      method: method,
      url: url,
      headers: headers,
      data: dontStringify ? data : qs.stringify(data)
    };
    return request;
  }

  getDefaultHeaders(includeTkn, isJSON) {
    const headers = {
      'Content-Type': isJSON ? 'application/json' : 'application/x-www-form-urlencoded'
    };

    if (includeTkn) {
      headers['Authorization'] = `Bearer ${this.getTkn()}`;
    }

    return headers;
  }

  getResponse(response) {
    try {
      return {
        status: response.data.status,
        msg: response.data.msg ? response.data.msg : "",
        error: response.data.error ? response.data.error : "",
        data: response.data.data
      };

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Failed to parseResponse", err);
    }

    return {
      status: 0,
      msg: "",
      error: "Unabled to parse response",
      data: null
    }
  }

  parseError(error) {
    try {

      if (!error?.response?.data?.error) {
        return this.FAILED_TO_PERFORM_OPERATION;
      }

      return error.response.data.error;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Failed to parseError", err);
    }

    return this.FAILED_TO_PERFORM_OPERATION;
  }

  setTkn(tkn) {

    if (tkn) {
      localStorage.setItem(this.VC_AG_TKN, tkn);
    } else {
      localStorage.removeItem(this.VC_AG_TKN, tkn);
    }
  }

  getTkn() {
    return localStorage.getItem(this.VC_AG_TKN);
  }

}

export default BaseService;